// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7075":"css/admin-app.6998","7233":"css/app.6998"}[chunkId] + ".css";
};